import React, { useEffect, useState } from "react";
import CustomDataTable from "../../Componant/CustomDataTable";
import { FaRegEdit, FaKey } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";
import { MdAdd } from "react-icons/md";
import Swal from "sweetalert2";
import UserDetailsPopup from "../../Componant/UserDetailsPopup ";
import { Tooltip } from "@mui/material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  ListItemText,
} from "@mui/material";
import axios from "../../customAxios";

const ManageNativeUser = () => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewContent, setPreviewContent] = useState("");
  const [copiedItem, setCopiedItem] = useState(null); // Track the last copied item
  const [data, setData] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [adminRoles, setAdminRoles] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [updateFormOpen, setUpdateFromOpen] = useState(false);
  const [changePasswordFormOpen, setChangePasswordUpdateFromOpen] =
    useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [formData, setFormData] = useState({
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    displayName: "",
    password: "",
    confirmPassword: "",
    adminRoles: [],
  });

  useEffect(() => {
    getAllUser();
    getAdminRoles();
  }, []);

  const getAllUser = () => {
    axios
      .get(
        `/nativeusers/api/v1/${process.env.REACT_APP_REGISTERED_APP_NAME}/getalluser`
      )
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAdminRoles = () => {
    axios
      .get(
        `/privilegedrole/api/v1/${process.env.REACT_APP_REGISTERED_APP_NAME}/adminrole`
      )
      .then((res) => {
        setAdminRoles(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleFormOpen = () => {
    setOpenForm(true);
  };

  const handleFormClose = () => {
    setOpenForm(false);
    setFormData({
      userName: "",
      firstName: "",
      lastName: "",
      email: "",
      displayName: "",
      password: "",
      confirmPassword: "",
      adminRoles: [],
    });
  };

  const handleUpdateFormClose = () => {
    setUpdateFromOpen(false);
    setFormData({
      userName: "",
      firstName: "",
      lastName: "",
      email: "",
      displayName: "",
      password: "",
      confirmPassword: "",
      adminRoles: [],
    });
  };

  const handleFormSubmit = () => {
    axios
      .post(
        `/nativeusers/api/v1/${process.env.REACT_APP_REGISTERED_APP_NAME}/createuser`,
        formData
      )
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          timer: 1500,
          text: "User Created Successfully",
          showConfirmButton: false,
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          timer: 1500,
          text: err,
          // showConfirmButton:false
        });
      });
  };

  const handleMultiSelectChange = (event) => {
    const {
      target: { value },
    } = event;
    setFormData({
      ...formData,
      adminRoles: typeof value === "string" ? value.split(",") : value,
    });
  };

  const handleOnClickUserName = async (userId, data) => {
    if (data) {
      setSelectedUser(data);
      setPopupOpen(true);
      return;
    }
    try {
      const response = await axios.get(
        `/nativeusers/api/v1/${process.env.REACT_APP_REGISTERED_APP_NAME}/getuser/${userId}`
      );
      setSelectedUser(response.data);
      setPopupOpen(true);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const handleEditClick = (userData) => {
    setSelectedUser(userData);
    setFormData({
      userName: userData.userName,
      firstName: userData.firstName,
      lastName: userData.lastName,
      email: userData.email,
      displayName: userData.displayName,
      adminRoles: userData.adminRoles || [],
      password: "", // You can choose to keep this field blank for updates
      confirmPassword: "",
    });
    setUpdateFromOpen(true);
  };

  const handleUpdateUser = () => {
    axios
      .put(
        `/nativeusers/api/v1/${process.env.REACT_APP_REGISTERED_APP_NAME}/updateuser/${selectedUser.userName}`,
        formData
      )
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          timer: 1500,
          text: "User Updated Successfully",
          showConfirmButton: false,
        });
        setPopupOpen(false);
        getAllUser(); // Refresh the user list
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          timer: 1500,
          text: err.response?.data?.message || "Failed to update user details",
        });
      });
  };

  const handleChangePasswordClick = (data) => {
    setChangePasswordUpdateFromOpen(true);
    setSelectedUser(data);
  };
  const handleChangePasswordUser = async () => {
    if(formData.password=="" && formData.confirmPassword==""){
      Swal.fire({
        icon: "warning",
        title: "warning",
        timer: 1500,
        text: "Enter Password and Confirm Password",
        // showConfirmButton: false,
      });
       return;
    }
    if(formData.password==formData.confirmPassword){
      Swal.fire({
        icon: "warning",
        title: "warning",
        timer: 1500,
        text: "Confirm Password not matched",
        // showConfirmButton: false,
      });
       return;
    }
    await axios
      .post(
        `/nativeusers/api/v1/${process.env.REACT_APP_REGISTERED_APP_NAME}/changepassword`,
        {
          userName: selectedUser.userName,
          password: formData.password,
        }
      )
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Success",
          timer: 1500,
          text: "Changed password successfully",
          showConfirmButton: false,
        });
        handleChangePasswordFormClose()
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          timer: 1500,
          text: err.response?.data?.message || "Failed to change password ",
        });
      });
  };

  const handleChangePasswordFormClose = () => {
    setChangePasswordUpdateFromOpen(false);
    setFormData({
      userName: "",
      firstName: "",
      lastName: "",
      email: "",
      displayName: "",
      password: "",
      confirmPassword: "",
      adminRoles: [],
    });
  };

  const columns = [
    {
      name: "Username",
      selector: (row) => (
        <div
          onClick={() => handleOnClickUserName(row.userName, row)}
          style={{
            fontWeight: "700",
            color: "var(--primary-color)",
            cursor: "pointer",
          }}
        >
          {row.userName}
        </div>
      ),
      sortable: true,
    },
    {
      name: "First Name",
      selector: (row) => row.firstName,
      sortable: true,
    },
    {
      name: "Last Name",
      selector: (row) => row.lastName,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <FaRegEdit
            style={{ cursor: "pointer" }}
            onClick={() => handleEditClick(row)}
            size={20}
            title="Edit User Details"
          />
          <FaKey
            onClick={() => handleChangePasswordClick(row.userName)}
            size={20}
            style={{ cursor: "pointer" }}
            title="Change Password"
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <div
        style={{ display: "flex", justifyContent: "end", margin: "8px 0px" }}
      >
        <button
          onClick={handleFormOpen}
          style={{
            borderRadius: "7px",
            background: "var(--primary-color)",
            color: "white",
            border: "none",
            padding: "8px 16px 8px 8px",
            fontSize: "1em",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <MdAdd
              style={{ fontWeight: "200", marginRight: "5px" }}
              size={20}
            />{" "}
            Add User
          </div>
        </button>
      </div>

      {/* Create user */}

      <Dialog open={openForm} onClose={handleFormClose} fullWidth maxWidth="sm">
        <DialogTitle>Add New User</DialogTitle>
        <DialogContent>
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.userName}
            onChange={(e) =>
              setFormData({ ...formData, userName: e.target.value })
            }
          />
          <TextField
            label="First Name"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.firstName}
            onChange={(e) =>
              setFormData({ ...formData, firstName: e.target.value })
            }
          />
          <TextField
            label="Last Name"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.lastName}
            onChange={(e) =>
              setFormData({ ...formData, lastName: e.target.value })
            }
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
          <TextField
            label="Display Name"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.displayName}
            onChange={(e) =>
              setFormData({ ...formData, displayName: e.target.value })
            }
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
          />
          <TextField
            label="Confirm Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.confirmPassword}
            onChange={(e) =>
              setFormData({ ...formData, confirmPassword: e.target.value })
            }
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Admin Roles</InputLabel>
            <Select
              multiple
              value={formData.adminRoles}
              onChange={handleMultiSelectChange}
              renderValue={(selected) => selected.join(", ")}
            >
              {adminRoles.map((i) => (
                <MenuItem key={i.adminRole} value={i.adminRole}>
                  <Checkbox
                    checked={formData.adminRoles.indexOf(i.adminRole) > -1}
                  />
                  <ListItemText primary={i.adminRole} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions
          style={{
            backgroundColor: "var(--background-color)",
            //   justifyContent: "center",
            padding: "10px",
          }}
        >
          <Button onClick={handleFormClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleFormSubmit}
            color="primary"
            variant="contained"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* update form  */}

      <Dialog
        open={updateFormOpen}
        onClose={handleUpdateFormClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Update User</DialogTitle>
        <DialogContent>
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.userName}
            onChange={(e) =>
              setFormData({ ...formData, userName: e.target.value })
            }
          />
          <TextField
            label="First Name"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.firstName}
            onChange={(e) =>
              setFormData({ ...formData, firstName: e.target.value })
            }
          />
          <TextField
            label="Last Name"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.lastName}
            onChange={(e) =>
              setFormData({ ...formData, lastName: e.target.value })
            }
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
          <TextField
            label="Display Name"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.displayName}
            onChange={(e) =>
              setFormData({ ...formData, displayName: e.target.value })
            }
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Admin Roles</InputLabel>
            <Select
              multiple
              value={formData.adminRoles}
              onChange={handleMultiSelectChange}
              renderValue={(selected) => selected.join(", ")}
            >
              {adminRoles.map((i) => (
                <MenuItem key={i.adminRole} value={i.adminRole}>
                  <Checkbox
                    checked={formData.adminRoles.indexOf(i.adminRole) > -1}
                  />
                  <ListItemText primary={i.adminRole} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleUpdateFormClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleUpdateUser}
            color="primary"
            variant="contained"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* User Change Password  */}
      <Dialog
        open={changePasswordFormOpen}
        onClose={handleChangePasswordFormClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
         <p style={{fontWeight:"700",color:"var(--primary-color)"}}>{selectedUser}</p>
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
          />
          <TextField
            label="Confirm Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.confirmPassword}
            onChange={(e) =>
              setFormData({ ...formData, confirmPassword: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleChangePasswordFormClose} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleChangePasswordUser}
            color="primary"
            variant="contained"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {selectedUser && (
        <UserDetailsPopup
          open={popupOpen}
          onClose={() => setPopupOpen(false)}
          userData={selectedUser}
        />
      )}

      <CustomDataTable title={"Manage User"} columns={columns} data={data} />
    </div>
  );
};

export default ManageNativeUser;
